import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"
import { gql } from "@apollo/client"

export const saveCopResolutionDecisions = api(async function saveCopResolutionDecisions({ id, decisions }) {
    return mutate(
        gql`
            mutation SaveCopResolutionDecisions($id: ID!, $decisions: JSON!) {
                saveCopResolutionDecisions(id: $id, decisions: $decisions)
            }
        `,
        { id, decisions },
        { returns: "saveCopResolutionDecisions" }
    )
})
